import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { appTranslationResource } from './app';
import translationResources from './resources';

export const translationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    TranslationBlueprint.make({
      name: 'app',
      params: { resource: appTranslationResource },
    }),
    ...translationResources.map((resource, index) =>
      TranslationBlueprint.make({
        name: `resource-${index}`,
        params: { resource },
      }),
    ),
  ],
});
